module.exports = __webpack_public_path__ + "static/media/full-service.d4bdfbdd.svg";